import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import messages from './messages';
import styles from './style.module.less';
import useSupportOnlineFormItem from '../../../../../components/app-header/help-menu-dropdown/hooks/use-support-online-form-item';
import UserDateTimezoneFormat from '../../../../../components/user-date-timezone-format';
import Global from '../../../../../store/global-selectors';
import { ChangeSubscriptionButtonWrapper } from '../../components/change-subscription-button-wrapper';
import { useTrackEvent, PageEvents, PageEventSourceStrings } from '../../hooks/use-track-event';
import { messages as commonMessages } from '../../messages';

const AccountActions = ({
  billingCycleEndDateTimeUTC = '',
  inactiveAccount = false,
  isPlanLocked = false,
  isSubscriptionExpired = false,
}) => {
  const sellerHomeCountry = useSelector(Global.selectSellerHomeCountry);
  const onlineFormItem = useSupportOnlineFormItem(sellerHomeCountry);
  const trackEvent = useTrackEvent(PageEvents.SUBSCRIPTION_CHANGE_START, PageEventSourceStrings.SUBSCRIPTION_CARD);

  return (
    <div className={styles['actions-wrapper']}>
      {!isPlanLocked && (
        <ChangeSubscriptionButtonWrapper
          className={styles.small}
          linkContainerClassName={classnames({ [styles['expired-margin']]: isSubscriptionExpired }, styles.actions)}
          onClickTrack={trackEvent}
          theme='link'
        >
          <FormattedMessage {...(inactiveAccount ? commonMessages.renewPlan : commonMessages.managePlan)} />
        </ChangeSubscriptionButtonWrapper>
      )}
      {inactiveAccount && isPlanLocked && onlineFormItem ? (
        <div className={classnames(styles['ctp-text'], styles.actions)}>
          <FormattedMessage
            {...messages.ctpCancellationNoticePaymentsAndSubscriptionPage}
            values={{
              endDate: <UserDateTimezoneFormat dateTime={billingCycleEndDateTimeUTC} />,
              supportLink: (chunks) => (
                <a href={onlineFormItem.url} rel={onlineFormItem.rel} target={onlineFormItem.target}>
                  {chunks}
                </a>
              ),
            }}
          />
        </div>
      ) : null}
      {isPlanLocked && !inactiveAccount && onlineFormItem ? (
        <div className={classnames(styles['ctp-text'], styles.actions)}>
          <FormattedMessage
            {...messages.ctpBillingLinkPaymentsAndSubscriptionPage}
            values={{
              supportLink: (chunks) => (
                <a href={onlineFormItem.url} rel={onlineFormItem.rel} target={onlineFormItem.target}>
                  {chunks}
                </a>
              ),
            }}
          />
        </div>
      ) : null}
    </div>
  );
};

AccountActions.propTypes = {
  billingCycleEndDateTimeUTC: PropTypes.string,
  inactiveAccount: PropTypes.bool,
  isPlanLocked: PropTypes.bool,
  isSubscriptionExpired: PropTypes.bool,
};

export default AccountActions;
